import { render, staticRenderFns } from "./LandlordSurvey.vue?vue&type=template&id=620106f6&scoped=true"
import script from "./LandlordSurvey.vue?vue&type=script&lang=js"
export * from "./LandlordSurvey.vue?vue&type=script&lang=js"
import style0 from "./LandlordSurvey.vue?vue&type=style&index=0&id=620106f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620106f6",
  null
  
)

export default component.exports